import { render } from "./topicCheck.vue?vue&type=template&id=ad57dc42&scoped=true"
import script from "./topicCheck.vue?vue&type=script&lang=js"
export * from "./topicCheck.vue?vue&type=script&lang=js"

import "./topicCheck.vue?vue&type=style&index=0&id=ad57dc42&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad57dc42"]])

export default __exports__